<div id="content">
    <div class="titlebox">Tonometry</div>
    <br><br>
    <div class="pt-2">
        <ag-grid-angular [headerHeight]="35" [rowHeight]="35" style="height: 500px; width: 100%;" (rowDoubleClicked)="navigate($event)" class="ag-theme-alpine" [rowData]="rowTonometry" [columnDefs]="columnTonometry">
        </ag-grid-angular>
    </div>
</div>